<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="教师id" prop="teacherId">
      <el-input v-model="dataForm.teacherId" placeholder="教师id"></el-input>
    </el-form-item>
    <el-form-item label="学段 0. 学前 1.小学 2. 初中 3. 高中 4. 大学" prop="gradeLevel">
      <el-input v-model="dataForm.gradeLevel" placeholder="学段 0. 学前 1.小学 2. 初中 3. 高中 4. 大学"></el-input>
    </el-form-item>
    <el-form-item label="年级" prop="grade">
      <el-input v-model="dataForm.grade" placeholder="年级"></el-input>
    </el-form-item>
    <el-form-item label="年级名称" prop="gradeName">
      <el-input v-model="dataForm.gradeName" placeholder="年级名称"></el-input>
    </el-form-item>
    <el-form-item label="科目" prop="subject">
      <el-input v-model="dataForm.subject" placeholder="科目"></el-input>
    </el-form-item>
    <el-form-item label="科目名称" prop="subjectName">
      <el-input v-model="dataForm.subjectName" placeholder="科目名称"></el-input>
    </el-form-item>
    <el-form-item label="引用的课程知识点id" prop="courseId">
      <el-input v-model="dataForm.courseId" placeholder="引用的课程知识点id"></el-input>
    </el-form-item>
    <el-form-item label="是否公开该备课" prop="isPublic">
      <el-input v-model="dataForm.isPublic" placeholder="是否公开该备课"></el-input>
    </el-form-item>
    <el-form-item label="课程标题" prop="title">
      <el-input v-model="dataForm.title" placeholder="课程标题"></el-input>
    </el-form-item>
    <el-form-item label="删除标志 0.删除" prop="delFlag">
      <el-input v-model="dataForm.delFlag" placeholder="删除标志 0.删除"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createTime">
      <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="更新时间" prop="updateTime">
      <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          teacherId: '',
          gradeLevel: '',
          grade: '',
          gradeName: '',
          subject: '',
          subjectName: '',
          courseId: '',
          isPublic: '',
          title: '',
          delFlag: '',
          createTime: '',
          updateTime: ''
        },
        dataRule: {
          teacherId: [
            { required: true, message: '教师id不能为空', trigger: 'blur' }
          ],
          gradeLevel: [
            { required: true, message: '学段 0. 学前 1.小学 2. 初中 3. 高中 4. 大学不能为空', trigger: 'blur' }
          ],
          grade: [
            { required: true, message: '年级不能为空', trigger: 'blur' }
          ],
          gradeName: [
            { required: true, message: '年级名称不能为空', trigger: 'blur' }
          ],
          subject: [
            { required: true, message: '科目不能为空', trigger: 'blur' }
          ],
          subjectName: [
            { required: true, message: '科目名称不能为空', trigger: 'blur' }
          ],
          courseId: [
            { required: true, message: '引用的课程知识点id不能为空', trigger: 'blur' }
          ],
          isPublic: [
            { required: true, message: '是否公开该备课不能为空', trigger: 'blur' }
          ],
          title: [
            { required: true, message: '课程标题不能为空', trigger: 'blur' }
          ],
          delFlag: [
            { required: true, message: '删除标志 0.删除不能为空', trigger: 'blur' }
          ],
          createTime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          updateTime: [
            { required: true, message: '更新时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/business/lesson/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.teacherId = data.lesson.teacherId
                this.dataForm.gradeLevel = data.lesson.gradeLevel
                this.dataForm.grade = data.lesson.grade
                this.dataForm.gradeName = data.lesson.gradeName
                this.dataForm.subject = data.lesson.subject
                this.dataForm.subjectName = data.lesson.subjectName
                this.dataForm.courseId = data.lesson.courseId
                this.dataForm.isPublic = data.lesson.isPublic
                this.dataForm.title = data.lesson.title
                this.dataForm.delFlag = data.lesson.delFlag
                this.dataForm.createTime = data.lesson.createTime
                this.dataForm.updateTime = data.lesson.updateTime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/business/lesson/${!this.dataForm.id ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'id': this.dataForm.id || undefined,
                'teacherId': this.dataForm.teacherId,
                'gradeLevel': this.dataForm.gradeLevel,
                'grade': this.dataForm.grade,
                'gradeName': this.dataForm.gradeName,
                'subject': this.dataForm.subject,
                'subjectName': this.dataForm.subjectName,
                'courseId': this.dataForm.courseId,
                'isPublic': this.dataForm.isPublic,
                'title': this.dataForm.title,
                'delFlag': this.dataForm.delFlag,
                'createTime': this.dataForm.createTime,
                'updateTime': this.dataForm.updateTime
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
